import React from 'react';
import '../MarsTheme.css';

const SectionContainer = ({ id, title, children, className, layout }) => {
    return (
        <section id={id} className={`mars-section ${className || ''}`} style={{ padding: '2rem 5%', minHeight: '60vh' }}>
            <h2 className="section-title fade-in">{title}</h2>

            {/* Responsive Grid/List Container */}
            <div className={layout === 'list' ? "portfolio-list-layout" : "portfolio-grid-layout"}>
                {children}
            </div>
        </section>
    );
};

export default SectionContainer;
